import { ArticleBiData, BlockId, blockNames, BlockType, SolutionInfo, SupportType } from '../types';

export function createSolutionListSolutionInfo(
  articleData: ArticleBiData[],
  position?: number,
): SolutionInfo {
  return {
    block_id: BlockId.SolutionList,
    block_name: blockNames[BlockId.SolutionList],
    block_position: 1,
    block_type: BlockType.SolutionList,
    block_details: articleData.map((article, index) => ({
      support_type: article.articleType || SupportType.Article,
      support_id: article.id,
      support_position: (position || 0) + index + 1, // increment value to start count from 1(not 0)
    })),
  };
}
